// src/utils/enderecoEntregaUtils.js
import { normalizeNullableText } from './stringUtils';

export const reconciliarCidadeEntrega = (cidadeId, cidades) =>
  cidades.find((cidade) => Number(cidade.id) === Number(cidadeId)) ||
  (cidades.length === 1 ? cidades[0] : null);

export const reconciliarBairroEntrega = (endereco, taxas) => {
  const bairros = taxas.filter((taxa) => Number(taxa.cidadeId) === Number(endereco?.cidadeId));
  const nome = normalizeNullableText(endereco?.bairro).toLocaleLowerCase('pt-BR');
  return bairros.find((taxa) => Number(taxa.id) === Number(endereco?.taxaEntregaBairroId)) ||
    bairros.find((taxa) => nome && normalizeNullableText(taxa.descricao).toLocaleLowerCase('pt-BR') === nome) || null;
};
